// extracted by mini-css-extract-plugin
export default {"tabsContainer":"Tabs_tabsContainer__TAR92","tabsList":"Tabs_tabsList__4I2GG","tab":"Tabs_tab__sw2ha","active":"Tabs_active__ubAf7","tabPanel":"Tabs_tabPanel__4Zebl"};